import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import QuestionBox from '../../../question-box';
import Task404Game from './game';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task404: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-404');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-404">
        <h2>zadanie 4</h2>
        <h3>{task?.title}</h3>
        <p>
            Znacie grę w kalambury? To jedna z najstarszych gier towarzyskich. Z pozoru łatwa, ale spróbujcie pokazać komuś bez mówienia, o co chodzi!
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Zagrajcie w kalambury! Klikając przycisk “Losuj”, wylosujcie tytuł książki (tak, żeby inni gracze go nie widzieli!) i postarajcie się bez słów przedstawić tytuł tak, żeby inni zgadli o jaki chodzi. Pamiętajcie, że mówienie w trakcie jest zabronione!
        </p>
        <Task404Game />
        <QuestionBox>
            <p>
                Jak myślicie, którym ze znanym Wam bohaterów literackich spodobałaby się taka gra?
            </p>
        </QuestionBox>

    </div>
}

export default Task404;
